import { onMounted, onUnmounted } from 'vue';

export const useClickOutside = (targetRef, callback) => {
  const handlePointerDown = (event) => {
    if (targetRef.value && !targetRef.value.contains(event.target)) callback();
  };

  onMounted(() => document.addEventListener('pointerdown', handlePointerDown));
  onUnmounted(() => document.removeEventListener('pointerdown', handlePointerDown));
};
